import * as React from "react";
import { SidebarNavigation } from "./SidebarNavigation";
import { SidebarFavoriteIcons } from "./SidebarFavoriteIcons";

export const SidebarIcons: React.FC = () => (
  <nav className="flex flex-col items-center space-y-2 px-0 py-4">
    <SidebarNavigation />
    <SidebarFavoriteIcons />
  </nav>
);
